<template>
  <div class="footer_container">
    <div class="footerHeadBar">
      <div class="itemGroup">
        <div :class="['barItem',show === 'contactus'? 'active': '']" @click="show = 'contactus'">{{$t('footerpages.contactus.ContactUs')}}</div>
        <div :class="['barItem',(show === 'joinus' || show === 'work')? 'active': '']" @click="show = 'joinus'">{{$t('footerpages.contactus.JoinUs')}}</div>
      </div>
    </div>
    <div class="footerBody">
      <div class="bodyContainer" v-show="show === 'contactus'">
        <div class="bodyHead">{{$t('footerpages.contactus.ContactUs')}}</div>
        <div class="bodyContent" style="position: relative;">
          <img src="../../assets/img/footerpages/contact-us2.jpg" width="1112" />
          <div class="textContainer">
            <!--上海达美乐比萨有限公司（总部）-->
            <div class="textRow">{{$t('footerpages.contactus.ShanghaiPizza')}}</div>
            <!--公司地址-->
            <div class="textRow">
              <div class="redBox">{{$t('footerpages.contactus.Address')}}</div>
              <div>{{$t('footerpages.contactus.AddressDetail')}}</div>
            </div>
            <!--联系电话-->
            <div class="textRow">
              <div class="redBox">{{$t('footerpages.contactus.Phone')}}</div>
              <div>021-53685888</div>
            </div>
            <!--邮编-->
            <div class="textRow">
              <div class="redBox">{{$t('footerpages.contactus.Zip')}}</div>
              <div>200235</div>
            </div>
          </div>
        </div>
      </div>
      <div class="bodyContainer" v-show="show === 'joinus'">
        <div class="bodyHead">{{$t('footerpages.contactus.JoinUs')}}</div>
        <div class="bodyContent">
          <img src="../../assets/img/footerpages/application2.png" width="1115" />
        </div>
        <div class="workBtn east" @click="east"></div>
        <div class="workBtn north" @click="north"></div>
      </div>
      <div class="bodyContainer" v-show="show === 'work'">
        <div class="bodyHead">{{$t('footerpages.contactus.JoinUs')}}</div>
        <div class="bodyContent">
          <img src="../../assets/img/footerpages/application.jpg" width="1115" />
        </div>
        <div class="startBtn" @click="jump"></div>
        <div class="backBtn" @click="show = 'joinus'"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "contactUs",
  data() {
    return {
      show: "contactus", //joinus, work
      email: "north" //east
    };
  },
  created() {
    if (this.$route.query.show) this.show = this.$route.query.show;
  },
  beforeRouteUpdate(to, form, next) {
    this.show = to.query.show;
    next();
  },
  methods: {
    east() {
      window.scrollTo(0, 0);
      this.show = "work";
      this.email = "east";
    },
    north() {
      window.scrollTo(0, 0);
      this.show = "work";
      this.email = "north";
    },
    jump() {
      if (this.email === "north") {
        window.location.href = "mailto:hrnorth@dominos.com.cn";
      } else {
        window.location.href = "mailto:hreast@dominos.com.cn";
      }
    }
  }
};
</script>

<style scoped lang="scss">
.footer_container {
  width: 100%;
  min-height: 520px;
  display: flex;
  flex-flow: column;
  position: relative;
}

.footerHeadBar {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  .itemGroup {
    width: 200px;
    height: 100%;
    display: flex;
    justify-content: space-around;

    .barItem {
      height: 100%;
      padding: 0 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      font-size: 14px;

      &:hover {
        text-decoration: underline;
      }
    }

    .active {
      text-decoration: underline;
    }
  }
}

.footerBody {
  width: 100%;
  min-height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  padding-top: 0;
  .bodyContainer {
    display: flex;
    flex-flow: column;
    border-radius: 5px;
    overflow: hidden;
    box-shadow: 2px 5px 8px rgba(0, 0, 0, 0.1);

    .bodyHead {
      width: 100%;
      height: 35px;
      background: #CF152D;
      color: white;
      text-align: left;
      padding-left: 20px;
      display: flex;
      align-items: center;
      font-size: 14px;
    }
  }
}

.textContainer {
  display: flex;
  flex-flow: column;
  justify-content: left;
  align-items: center;
  position: absolute;
  top: 50px;
  left: 50px;

  .redBox {
    background-color: $theme_red;
    color: #fff;
    text-align: center;
    width: 70px;
    font-size: 14px;
    margin-right: 10px;
  }

  .textRow {
    width: 420px;
    display: flex;
    margin-bottom: 10px;
    justify-content: left;
    color: black;
    font-size: 14px;
  }
}

.workBtn {
  position: absolute;
  right: 80px;
  cursor: pointer;
}

.east {
  width: 180px;
  height: 70px;
  bottom: 118px;
}

.north {
  width: 180px;
  height: 70px;
  bottom: 42px;
}

.startBtn {
  width: 180px;
  height: 100px;
  position: absolute;
  bottom: 105px;
  left: 170px;
  cursor: pointer;
}

.backBtn {
  width: 180px;
  height: 100px;
  position: absolute;
  bottom: 105px;
  right: 180px;
  cursor: pointer;
}
</style>
